import { Timestamp } from 'firebase/firestore'
// 사용처: farmfree-functions, farmfree-admin

/**
 * SMS 템플릿 카테고리
 */
export enum TemplateCategory {
  SINGLE = 'SINGLE', // 1개 배송
  DOUBLE_SAME = 'DOUBLE_SAME', // 2개 배송 (같은 택배사)
  DOUBLE_DIFFERENT = 'DOUBLE_DIFFERENT', // 2개 배송 (다른 택배사)
  TRIPLE_PLUS = 'TRIPLE_PLUS', // 3개 이상 배송
}

/**
 * 템플릿 타입
 */
export enum TemplateType {
  DELIVERY = 'DELIVERY', // 택배발송 안내
  ORDER_CONFIRM = 'ORDER_CONFIRM', // 주문 확인
  CUSTOM = 'CUSTOM', // 사용자 정의
}

/**
 * 템플릿 채널 타입
 */
export enum TemplateChannel {
  SMS = 'SMS', // 문자 메시지
  KAKAO = 'KAKAO', // 카카오톡 알림톡
}

/**
 * SMS 템플릿
 */
export interface SmsTemplate {
  id: string
  name: string // 템플릿 이름
  type: TemplateType // 템플릿 종류
  channel: TemplateChannel // 채널 (SMS/카카오톡)
  category: TemplateCategory // 배송 개수별 카테고리
  content: string // 템플릿 내용 ({배송정보} 등 변수 포함)
  isDefault: boolean // 기본 선택 템플릿
  isActive: boolean // 활성화 여부
  order: number // 정렬 순서
  companyId: string // 회사 ID
  dateCreated: Timestamp
  dateModified: Timestamp
}

/**
 * 3개 이상 배송 시 특별 템플릿
 */
export interface MultiDeliveryTemplate extends SmsTemplate {
  firstMessage: string // 첫 번째 메시지 (인사말)
  deliveryMessage: string // 배송 정보 메시지 템플릿
}

/**
 * 템플릿 변수
 */
export interface TemplateVariable {
  key: string // 변수 키 (예: 배송정보)
  label: string // 표시 이름
  placeholder: string // 미리보기용 예시 데이터
  required: boolean // 필수 여부
}

/**
 * 배송 정보 (템플릿 변수 치환용)
 */
export interface DeliveryInfo {
  courier: string // 택배사명
  trackingNumber: string // 송장번호
  formattedNumber?: string // 포맷된 송장번호 (1234-5678-9012)
}

/**
 * 템플릿 미리보기 데이터
 */
export interface TemplatePreviewData {
  deliveries: DeliveryInfo[] // 배송 정보 목록
  shopName?: string // 농장/가게 이름
  customerName?: string // 고객명
  orderNumber?: string // 주문번호
}
